<template>
  <section class="reimbursement-container">
    <!--工具条-->
    <toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
    ></toolbar>

    <el-main class="reimbursement-main">
      <!--列表-->
      <el-table
        :data="listData"
        highlight-current-row
        @current-change="selectCurrentRow"
        v-loading="listLoading"
        @selection-change="selsChange"
        @row-dblclick="handleEdit"
        class="reimbursement-table"
      >
        <el-table-column
          type="selection"
          width="55"
        >
        </el-table-column>
        <el-table-column
          type="index"
          width="60"
          label="#"
        >
        </el-table-column>
        <el-table-column
          prop="BillNo"
          label="报销单号"
          min-width="120"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="CostType"
          label="费用类型"
          min-width="100"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="Amount"
          label="金额"
          min-width="100"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="IsDG"
          label="是否对公"
          :formatter="formatIsDG"
          min-width="100"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="CreateTime"
          label="创建日期"
          :formatter="formatRBDate"
          min-width="160"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="CreateBy"
          label="创建人"
          min-width="100"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="StatusName"
          label="状态"
          min-width="100"
          sortable
        >
        </el-table-column>
      </el-table>
    </el-main>

    <!--工具条-->
    <el-col
      :span="24"
      class="toolbar pagination-toolbar"
    >
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        background
      >
      </el-pagination>
    </el-col>

    <!--新增/编辑/查看界面-->
    <el-dialog
      :title="status==0?'新增报销单':status==1?'编辑报销单':'查看报销单'"
      :visible.sync="FormVisible"
      v-model="FormVisible"
      :close-on-click-modal="false"
      @close='handleget'
      class="reimbursement-dialog"
      width="90%"
      top="30px"
    >
      <div class="dialog-content">
        <el-row
          type="flex"
          justify="space-between"
          class="dialog-header-row"
        >
          <el-col
            v-if="status!=2"
            :span="4"
          >
            <el-button
              type="primary"
              @click="addreuser"
              size="small"
              icon="el-icon-plus"
            >
              新增报销人
            </el-button>
          </el-col>
        </el-row>

        <!-- 报销明细表 -->
        <div class="table-section">
          <div class="section-title">报销明细</div>
          <el-table
            :data="DataForm.Entry"
            border
            max-height="250"
            class="entry-table"
          >
            <el-table-column
              prop="StaffID"
              label="报销人"
              min-width="120"
            >
              <template slot-scope="scope">
                <el-select
                  :disabled="status==2"
                  v-model="scope.row.StaffID"
                  @change="userchange(scope.row)"
                  placeholder="请选择"
                  filterable
                  size="small"
                >
                  <el-option
                    :key="0"
                    :label="'未选择报销人'"
                    :value="0"
                  ></el-option>
                  <el-option
                    v-for="item in users"
                    :key="item.uID"
                    :label="item.uRealName"
                    :value="item.uID"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              prop="CostDepID"
              label="费用归属部门"
              min-width="140"
            >
              <template slot-scope="scope">
                <el-select
                  :disabled="status==2"
                  v-model="scope.row.CostDepID"
                  placeholder="请选择"
                  @change="newgetbudget(scope.row)"
                  filterable
                  size="small"
                >
                  <el-option
                    :key="0"
                    :label="'未选择'"
                    :value="0"
                  ></el-option>
                  <el-option
                    v-for="item in deps"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item.Id"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              prop="RBDate"
              label="费用日期"
              min-width="150"
            >
              <template slot-scope="scope">
                <el-date-picker
                  :disabled="status==2"
                  size="small"
                  v-model="scope.row.RBDate"
                  type="date"
                  placeholder="选择日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  style="width: 100%;"
                >
                </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column
              prop="CostTypeId"
              label="费用类型"
              min-width="150"
            >
              <template slot-scope="scope">
                <el-select
                  :disabled="status==2"
                  v-model="scope.row.CostTypeId"
                  placeholder="请选择"
                  @change="newgetbudget(scope.row)"
                  size="small"
                >
                  <el-option
                    :key="0"
                    :label="'未选择费用类型'"
                    :value="0"
                  ></el-option>
                  <el-option
                    v-for="item in costtypes"
                    :key="item.Id"
                    :label="item.CostTypeName"
                    :value="item.Id"
                    :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              prop="Subject"
              label="项目"
              min-width="120"
            >
              <template slot-scope="scope">
                <el-select
                  :disabled="status==2"
                  v-model="scope.row.Subject"
                  placeholder="请选择"
                  @change="newgetbudget(scope.row)"
                  size="small"
                >
                  <el-option
                    :key="0"
                    :label="'未选择项目'"
                    :value="0"
                  ></el-option>
                  <el-option
                    v-for="item in subjects"
                    :key="item.Number"
                    :label="item.Name"
                    :value="item.Number"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              prop="YSDATE"
              label="预算区间"
              min-width="150"
            >
              <template slot-scope="scope">
                <el-date-picker
                  :disabled="status==2"
                  size="small"
                  v-model="scope.row.YSDATE"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  @change="newgetbudget(scope.row)"
                  style="width: 100%;"
                >
                </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column
              prop="CurSurplus"
              label="剩余额度"
              min-width="100"
            >
            </el-table-column>
            <el-table-column
              prop="YearCurSurplus"
              label="年度剩余"
              min-width="100"
            >
            </el-table-column>
            <el-table-column
              prop="Amount"
              label="本次报销额"
              min-width="120"
            >
              <template slot-scope="scope">
                <el-input
                  :disabled="status==2"
                  v-model="scope.row.Amount"
                  @blur="checkAmount(scope.row)"
                  size="small"
                  type="number"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="80"
              v-if="status!=2"
            >
              <template slot-scope="scope">
                <el-button
                  :disabled="status==2"
                  @click="deleteUser(scope.$index)"
                  type="text"
                  size="small"
                  icon="el-icon-delete"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 发票信息上传区域 -->
        <div class="upload-section" v-if="status!=2">
          <div class="section-title">发票信息</div>
          <el-row
            :gutter="20"
            class="upload-row"
          >
            <el-col :span="16">
              <el-upload
                class="upload-demo"
                ref="add-upload"
                :action="UploadUrl()"
                :on-preview="handlePreview"
                :headers="headers"
                :on-remove="handleRemove"
                :file-list="fileList"
                :on-success="handlesuccess"
                multiple
                :auto-upload="false"
              >
                <el-button
                  type="primary"
                  slot="trigger"
                  size="small"
                >
                  <i class="el-icon-upload2"></i>
                  选取文件
                </el-button>
                <el-button
                  type="success"
                  v-loading.fullscreen.lock="loading"
                  size="small"
                  style="margin-left: 10px;"
                  @click="submitUpload('add')"
                >
                  <i class="el-icon-upload"></i>
                  上传到服务器
                </el-button>
                <div
                  slot="tip"
                  class="el-upload__tip"
                >
                  文件名中不可含有特殊符号且单个文件不能超过4M
                </div>
              </el-upload>
            </el-col>
            <el-col :span="8">
              <div class="invoice-buttons">
                <el-button
                  type="primary"
                  size="small"
                  @click="addinvoice"
                >
                  <i class="el-icon-plus"></i>
                  手工新增
                </el-button>
                <el-button
                  type="primary"
                  size="small"
                  @click="chooseMyRB"
                >
                  <i class="el-icon-document"></i>
                  从我的发票选择
                </el-button>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- 发票明细表 -->
        <div class="table-section">
          <div class="section-title">发票明细</div>
          <el-table
            :data="DataForm.EntryInvoiceinfo"
            border
            max-height="250"
            class="invoice-table"
          >
            <el-table-column
              prop="InvoiceName"
              label="发票名称"
              min-width="150"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="InvoiceNo"
              label="发票号码"
              min-width="120"
            >
            </el-table-column>
            <el-table-column
              prop="ItemName"
              label="项目名称"
              min-width="150"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.ItemName"
                  :disabled="(scope.row.Type!=99 || status==2)"
                  size="small"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              :formatter="formatData"
              prop="InvoiceDate"
              label="开票日期"
              min-width="130"
            >
              <template slot-scope="scope">
                <el-date-picker
                  size="small"
                  v-model="scope.row.InvoiceDate"
                  type="date"
                  :disabled="true"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column
              prop="Amount"
              label="金额"
              min-width="100"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.Amount"
                  :disabled="scope.row.Type!=99  || status==2"
                  @blur="getfpsum($event)"
                  size="small"
                  type="number"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="Count"
              label="张数"
              min-width="80"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.Count"
                  :disabled="scope.row.Type!=99 "
                  @blur="getfpsum($event)"
                  size="small"
                  type="number"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="发票状态"
              min-width="100"
            >
              <template slot-scope="scope">
                <div class="status-tag">
                  <el-tag
                    size="small"
                    :type="scope.row.Status === '0' ? 'success'  :scope.row.Status === '1' ? 'warning'  :'danger'"
                  >
                    {{ scope.row.StatusInfo }}
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="80"
              v-if="status!=2"
            >
              <template slot-scope="scope">
                <el-button
                  @click="deleteInvoice(scope.row)"
                  type="text"
                  size="small"
                  icon="el-icon-delete"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div
        slot="footer"
        class="dialog-footer"
        v-if="status!=2"
      >
        <el-button @click.native="FormVisible = false ,status=0">
          <i class="el-icon-close"></i>
          取消
        </el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="Loading"
        >
          <i class="el-icon-check"></i>
          提交
        </el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      @close='handleget'
      width="80%"
    >
      <el-row
        type="flex"
        justify="space-between"
      >
        <el-col :span="2">
          <div>
            <el-button
              type="primary"
              @click="addreuser"
            >
              新增报销人
            </el-button>
          </div>
        </el-col>
        <el-col
          :span="6"
          v-if="false"
        >
          <div>
            <el-tag>{{Hwarning}}</el-tag>
          </div>
        </el-col>
      </el-row>

      <el-table
        :data="editForm.Entry"
        border
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column
          prop="StaffID"
          label="报销人"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.StaffID"
              @change="userchange(scope.row)"
              placeholder="请选择"
            >
              <el-option
                :key="0"
                :label="'未选择报销人'"
                :value="0"
              ></el-option>
              <el-option
                v-for="item in users"
                :key="item.uID"
                :label="item.uRealName"
                :value="item.uID"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="CostDepID"
          label="费用归属部门"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.CostDepID"
              placeholder="请选择"
            >
              <el-option
                :key="0"
                :label="'未选择部门'"
                :value="0"
              ></el-option>
              <el-option
                v-for="item in deps"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="RBDate"
          label="费用日期"
        >
          <template slot-scope="scope">
            <el-date-picker
              style="width:95%"
              v-model="scope.row.RBDate"
              type="date"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column
          prop="Type"
          label="费用类型"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.CostTypeId"
              placeholder="请选择"
              @change="newgetbudget(scope.row)"
            >
              <el-option
                :key="0"
                :label="'未选择费用类型'"
                :value="0"
              ></el-option>
              <el-option
                v-for="item in costtypes"
                :key="item.Id"
                :label="item.CostTypeName"
                :value="item.Id"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="Subject"
          label="项目"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.Subject"
              placeholder="请选择"
            >
              <el-option
                :key="0"
                :label="'未选择项目'"
                :value="0"
              ></el-option>
              <el-option
                v-for="item in subjects"
                :key="item.Number"
                :label="item.Name"
                :value="item.Number"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          v-if="show"
          prop="Amount"
          type='number'
          label="出差天数"
        >
          <template slot-scope="scope">
            <el-input v-model="scope.row.Amount"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          v-if="show"
          prop="Amount"
          type='number'
          label="标准(餐+住)"
        >
        </el-table-column>
        <el-table-column
          prop="YSDATE"
          label="预算区间"
        >
          <template slot-scope="scope">
            <el-date-picker
              style="width:90%"
              v-model="scope.row.YSDATE"
              type="date"
              placeholder="选择日期"
              format="yyyy 年 MM 月 dd 日"
              :picker-options="pickerOptions"
              @change="newgetbudget(scope.row)"
            >
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column
          prop="CurSurplus"
          label="剩余额度"
        >
        </el-table-column>
        <el-table-column
          prop="YearCurSurplus"
          label="年度剩余额度"
        >
        </el-table-column>
        <el-table-column
          prop="Amount"
          type='number'
          label="本次报销额"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.Amount"
              @blur="checkAmount(scope.row)"
              ref="input"
            ></el-input>
            <!-- <el-input-number
              size='small'
              :controls='false'
              v-model="scope.row.Amount"
            ></el-input-number> -->
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              @click="deleteUser(scope.$index)"
              type="text"
              size="small"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-row
        :gutter="3"
        class="el-row"
      >
        <el-upload
          class="upload-demo"
          ref="edit-upload"
          :action="UploadUrl()"
          :headers="headers"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :file-list="fileList"
          :on-success="handlesuccess"
          multiple
          :auto-upload="false"
        >
          <el-button
            type="primary"
            slot="trigger"
            size="small"
          >选取文件</el-button>
          <el-button
            v-loading.fullscreen.lock="loading"
            type="success"
            size="small"
            style="margin-left: 10px;"
            @click="submitUpload('edit')"
          >上传到服务器</el-button>
          <div
            slot="tip"
            class="el-upload__tip"
          >文件名中不可含有特殊符号且单个文件不能超过4M</div>
        </el-upload>
        <el-col :span="2">
          <el-button
            type="primary"
            size="small"
            @click="addinvoice"
          >
            手工新增
          </el-button>
        </el-col>
        <el-col :span="2">
          <el-button
            type="primary"
            size="small"
            @click="chooseMyRB"
          >
            从我的发票选择
          </el-button>
        </el-col>
      </el-row>
      <el-table
        :data="editForm.EntryInvoiceinfo"
        border
        style="width: 100%; margin-top: 40px;"
      >

        <el-table-column
          prop="InvoiceName"
          label="发票名称"
          width="180"
        >

        </el-table-column>
        <el-table-column
          prop="InvoiceNo"
          label="发票号码"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="ItemName"
          label="项目名称"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.ItemName"
              :disabled="scope.row.Type!=99"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column
          :formatter="formatData"
          prop="InvoiceDate"
          label="开票日期"
        >
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.InvoiceDate"
              align="right"
              style="width:90%"
              :disabled="true"
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </template>

        </el-table-column>
        <el-table-column
          prop="Amount"
          label="金额"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.Amount"
              :disabled="scope.row.Type!=99"
              @blur="getfpsum($event)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="Count"
          label="张数"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.Count"
              :disabled="scope.row.Type!=99"
              @blur="getfpsum($event)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="发票状态"
          width="180"
        >
          <template slot-scope="scope">
            <div
              slot="reference"
              class="name-wrapper"
            >
              <el-tag
                size="medium"
                :type="scope.row.Status === '0' ? 'success'  :scope.row.Status === '1' ? 'warning'  :'danger'"
              >{{ scope.row.StatusInfo }}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              @click="deleteInvoice(scope.row)"
              type="text"
              size="small"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table style="width: 100%; margin-top: 40px;">
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
        >提交</el-button>
      </div>
    </el-dialog>

    <!--查看界面-->
    <el-dialog
      title="查看"
      :visible.sync="readFormVisible"
      v-model="readFormVisible"
      :close-on-click-modal="false"
      @close='handleget'
      width="80%"
    >
      <el-table
        :data="editForm.Entry"
        border
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column
          prop="StaffID"
          label="报销人"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.StaffID"
              :disabled="true"
              @change="userchange(scope.row)"
              placeholder="请选择"
            >
              <el-option
                :key="0"
                :label="'未选择报销人'"
                :value="0"
              ></el-option>
              <el-option
                v-for="item in users"
                :key="item.uID"
                :label="item.uRealName"
                :value="item.uID"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="CostDepID"
          label="费用归属部门"
        >
          <template slot-scope="scope">
            <el-select
              :disabled="true"
              v-model="scope.row.CostDepID"
              placeholder="请选择"
            >
              <el-option
                :key="0"
                :label="'未选择部门'"
                :value="0"
              ></el-option>
              <el-option
                v-for="item in deps"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="RBDate"
          label="费用日期"
        >
          <template slot-scope="scope">
            <el-date-picker
              style="width:95%"
              v-model="scope.row.RBDate"
              :disabled="true"
              type="date"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column
          prop="Type"
          label="费用类型"
        >
          <template slot-scope="scope">
            <el-select
              :disabled="true"
              v-model="scope.row.CostTypeId"
              placeholder="请选择"
              @change="newgetbudget(scope.row)"
            >
              <el-option
                :key="0"
                :label="'未选择费用类型'"
                :value="0"
              ></el-option>
              <el-option
                v-for="item in costtypes"
                :key="item.Id"
                :label="item.CostTypeName"
                :value="item.Id"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="Subject"
          label="项目"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.Subject"
              placeholder="请选择"
              :disabled="true"
            >
              <el-option
                :key="0"
                :label="'未选择项目'"
                :value="0"
              ></el-option>
              <el-option
                v-for="item in subjects"
                :key="item.Number"
                :label="item.Name"
                :value="item.Number"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          v-if="show"
          prop="Amount"
          type='number'
          label="出差天数"
        >
          <template slot-scope="scope">
            <el-input v-model="scope.row.Amount"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          v-if="show"
          prop="Amount"
          type='number'
          label="标准(餐+住)"
        >
        </el-table-column>
        <el-table-column
          prop="YSDATE"
          label="预算区间"
        >
          <template slot-scope="scope">
            <el-date-picker
              style="width:90%"
              v-model="scope.row.YSDATE"
              type="date"
              placeholder="选择日期"
              format="yyyy 年 MM 月 dd 日"
              :picker-options="pickerOptions"
              @change="newgetbudget(scope.row)"
            >
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column
          prop="CurSurplus"
          label="剩余额度"
        >
        </el-table-column>
        <el-table-column
          prop="YearCurSurplus"
          label="年度剩余额度"
        >
        </el-table-column>
        <el-table-column
          prop="Amount"
          type='number'
          label="本次报销额"
        >
          <template slot-scope="scope">
            <el-input
              :disabled="true"
              v-model="scope.row.Amount"
              @blur="checkAmount(scope.row)"
              ref="input"
            ></el-input>
            <!-- <el-input-number
              size='small'
              :controls='false'
              v-model="scope.row.Amount"
            ></el-input-number> -->
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              :disabled="true"
              @click="deleteUser(scope.$index)"
              type="text"
              size="small"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-table
        :data="editForm.EntryInvoiceinfo"
        border
        style="width: 100%; margin-top: 40px;"
      >

        <el-table-column
          prop="InvoiceName"
          label="发票名称"
          width="180"
        >

        </el-table-column>
        <el-table-column
          prop="InvoiceNo"
          label="发票号码"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="ItemName"
          label="项目名称"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.ItemName"
              :disabled="scope.row.disabled"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column
          :formatter="formatData"
          prop="InvoiceDate"
          label="开票日期"
        >
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.InvoiceDate"
              align="right"
              style="width:90%"
              :disabled="true"
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </template>

        </el-table-column>
        <el-table-column
          prop="Amount"
          label="金额"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.Amount"
              :disabled="scope.row.disabled"
              @blur="getfpsum($event)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="Count"
          label="张数"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.Count"
              :disabled="scope.row.disabled"
              @blur="getfpsum($event)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="发票状态"
          width="180"
        >
          <template slot-scope="scope">
            <div
              slot="reference"
              class="name-wrapper"
            >
              <el-tag
                size="medium"
                :type="scope.row.Status === '0' ? 'success'  :scope.row.Status === '1' ? 'warning'  :'danger'"
              >{{ scope.row.StatusInfo }}</el-tag>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          fixed="right"
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              @click="deleteInvoice(scope.row)"
              :disabled="true"
              type="text"
              size="small"
            >删除</el-button>
          </template>
        </el-table-column> -->
      </el-table style="width: 100%; margin-top: 40px;">
    </el-dialog>

    <!--我的发票界面-->
    <el-dialog
      title="我的发票"
      :visible.sync="myRBFormVisible"
      v-model="myRBFormVisible"
      :close-on-click-modal="false"
      width="80%"
    >
      <template>
        <el-row>
          <el-table
            :data="myRB"
            @selection-change="myRBselsChange"
            @row-dblclick="handleChoose"
            @current-change="myRBselectCurrentRow"
          >
            <el-table-column
              type="selection"
              width="50"
            >
            </el-table-column>
            <el-table-column
              type="index"
              width="80"
            >
            </el-table-column>
            <el-table-column
              prop="InvoiceName"
              label="发票名称"
              width="180"
            >

            </el-table-column>
            <el-table-column
              prop="InvoiceNo"
              label="发票号码"
              width="180"
            >
            </el-table-column>
            <el-table-column
              prop="ItemName"
              label="项目名称"
            >
            </el-table-column>
            <el-table-column
              :formatter="formatData"
              prop="InvoiceDate"
              sortable
              label="开票日期"
            >
            </el-table-column>
            <el-table-column
              :formatter="formatData2"
              prop="ModifyTime"
              sortable
              label="最近更新日期"
            >
            </el-table-column>
            <el-table-column
              prop="Amount"
              sortable
              label="金额"
            >
            </el-table-column>
            <el-table-column
              prop="Count"
              label="张数"
            >
            </el-table-column>
            <el-table-column
              label="发票状态"
              width="180"
            >
              <template slot-scope="scope">
                <div
                  slot="reference"
                  class="name-wrapper"
                >
                  <el-tag
                    size="medium"
                    :type="scope.row.Status === '0' ? 'success'  :scope.row.Status === '1' ? 'warning'  :'danger'"
                  >{{ scope.row.StatusInfo }}</el-tag>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <!--工具条-->
        <el-col
          :span="24"
          class="toolbar"
        >
          <el-pagination
            layout="prev, pager, next"
            @current-change="myRBhandleCurrentChange"
            :page-size="1000"
            :total="myRBtotal"
            style="float:right;"
          >
          </el-pagination>
        </el-col>
        <div
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click.native="myRBFormVisible = false">取消</el-button>
          <el-button
            type="primary"
            @click.native="SubmitChooseinvoice"
          >提交</el-button>
        </div>
      </template>
    </el-dialog>

    <!--下推界面-->
    <el-dialog
      title="报销说明"
      :visible.sync="pushFormVisible"
      v-model="pushFormVisible"
      :close-on-click-modal="false"
      @close='handleget'
      width="80%"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-row type="flex">
          <el-col :span="24">
            <el-form-item>
              <div style="font-size:16px">发生“招待费”和“其他费用”时，列出何处发生，联系人姓名，职务，代表公司
                发生“差旅费”，列明出差事由。</div>
              <div style="font-size:16px">如有新项目，请写明。</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          justify-content="flex-start"
          wrap="nowrap"
          class="pushrow"
        >
          <div style="display: flex;align-items:center;">
            <el-checkbox v-model="pushForm.IsDG">是否对公</el-checkbox>
          </div>

          <div
            v-if="pushForm.IsDG"
            style="display: flex;align-items:center;"
          >
            收款方名称 :&nbsp&nbsp
            <el-input
              size="small"
              :disabled="status==2"
              style="width:4rem"
              v-model="pushForm.SKFMC"
            >
            </el-input>
          </div>

          <div
            v-if="pushForm.IsDG"
            style="display: flex;align-items:center;"
          >
            收款方开户银行 :&nbsp&nbsp
            <el-input
              size="small"
              :disabled="status==2"
              style="width:4rem"
              v-model="pushForm.SKFKHYH"
            >
            </el-input>
          </div>

          <div
            v-if="pushForm.IsDG"
            style="display: flex;align-items:center;"
          >
            收款方银行账户 :&nbsp&nbsp
            <el-input
              size="small"
              :disabled="status==2"
              style="width:4rem"
              v-model="pushForm.SKFYHZH"
            >
            </el-input>
          </div>
        </el-row>
        <el-row type="flex">

          <el-col :span="24">
            <el-form-item
              label="说明"
              prop="Remark"
            >
              <el-input
                :rows="4"
                type="textarea"
                v-model="pushForm.Remark"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click.native="pushFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="pushSubmit"
          :loading="listLoading"
        >保存</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import util from '../../../util/date'
import { testapi, getUserListPage, PushRB, getListInvoicePage, removeRB, SubmitRB, batchRemoveUser, addRB, getDepListPage, getDictionaryListPage, getRBListPage, getCostTypeListPage, getbudget, checkRB, editRB, ReSubmitRB } from '../../api/api';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import printmb from "../../printer/mb/rbprinter2";
import Cookies from 'js-cookie'

export default {
  components: { Toolbar },
  data() {
    return {
      pickerOptions: {
        disabledDate(v) {
          // return v.getTime() < new Date().getTime() - 86400000;
          // return v.getTime() < new Date().getTime() - 86400000;
        }
      },
      filters: {
        name: ''
      },
      headers: {
        Authorization: ''
      },
      defaultHeight: {
        height: ""
      },
      Hwarning: '',
      fileList: [],
      huanjing: '',
      users: [],
      show: false,
      listData: [],
      reuser: [],
      deps: [],
      subjects: [],
      costtypes: [],
      roles: [],
      total: 0,
      myRBtotal: 0,
      buttonList: [],
      currentRow: null,
      myRBcurrentRow: null,
      page: 1,
      myRBpage: 1,
      listLoading: false,
      loading: false,
      sels: [],//列表选中列
      myRBsels: [],//列表选中列
      UploadPath: '',
      testUploadPath: '',
      DownPath: '',
      testDownPath: '',
      InvoiceInfo: [],
      addDialogFormVisible: false,
      editFormVisible: false,//编辑界面是否显示
      readFormVisible: false,//查看界面是否显示
      myRBFormVisible: false,//我的发票界面是否显示
      pushFormVisible: false,//下推界面是否显示
      editLoading: false,
      readLoading: false,
      editFormRules: {
      },
      //编辑界面数据
      editForm: {
        id: 0,
        uID: 0,
        RIDs: 0,
        uLoginName: '',
        uRealName: '',
        name: '',
        sex: -1,
        age: 0,
        birth: '',
        addr: ''
      },
      //编辑界面数据
      readForm: {
        id: 0,
        uID: 0,
        RIDs: 0,
        uLoginName: '',
        uRealName: '',
        name: '',
        sex: -1,
        age: 0,
        birth: '',
        addr: ''
      },
      pushForm: {
        IsDG: false,
        SKFMC: '',
        SKFKHYH: '',
        SKFYHZH: '',
        Remark: ''
      },
      addFormVisible: false,//新增界面是否显示
      addLoading: false,
      addFormRules: {
      },
      //新增界面数据
      addForm: {
        Entry: {}
      }
      ,
      myRB: [],
      RBData: [],
      spanArr: [],
      spanArr2: [],
      FormVisible: false,//编辑界面是否显示
      DataForm: {
        Entry: {}
      },
      Loading: false,
      status: 0,
      IsDG: false,
    }
  },
  methods: {
    getHeight() {
      this.defaultHeight.height = window.innerHeight - 250 + "px";
    },
    checkAmount(row) {
      var rows = [];
      rows.push(row);
      var msg = this.checkAmounts(rows);
      if (msg.length > 0) {
        this.$message({
          dangerouslyUseHTMLString: true,
          message: msg,
          type: "error"
        });
      }
    },
    checkAmounts(rows) {
      var message = '';
      rows.forEach(function(item) {
        if (item.Amount > item.CurSurplus) {
          message = '超额！请重输或与财务确认！' + '<br/>';
        }
        if (item.Amount < item.YearCurSurplus && item.Amount > item.CurSurplus) {
          message = '本月超额！请尝试次月报销或与财务确认！' + '<br/>';
        }
      });
      return message;
    },
    addreuser() {
      //控制只让选一种费用类型
      var tmp = this.DataForm;
      if (tmp.Entry.length > 0) {
        var tmpCostType = tmp.Entry[0].CostTypeId;
        this.costtypes.forEach(function(item) {
          if (item.Id != tmpCostType) {
            item['disabled'] = true;
          }
        });
      }
      var userid = JSON.parse(window.localStorage.user).uID;
      debugger
      console.log("tmp.Entry", tmp.Entry)
      tmp.Entry.push({
        tmpid: 'tmp' + tmp.Entry.length,
        // StaffID: '',
        StaffID: tmp.Entry.length === 0 ? userid : '',
        DepID: '',
        CostDepID: '',
        CostTypeId: '',
        Amount: 0,
        CurBudget: 0,
        CurSurplus: 0,
        Subject: '002',
        RBDate: new Date()
      }
      );
      if (tmp.Entry.length === 1) this.userchange(tmp.Entry[0])
    },
    getNow() {
      let dateTime
      let yy = new Date().getFullYear()
      let mm = new Date().getMonth() + 1
      let dd = new Date().getDate()
      let hh = new Date().getHours()
      let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes()
        :
        new Date().getMinutes()
      let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds()
        :
        new Date().getSeconds()
      dateTime = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss
      console.log(dateTime)
      return dateTime
    },
    deleteUser(index) {
      var tmp = this.DataForm;
      tmp.Entry.splice(index, 1);

      //解除控制只让选一种费用类型
      if (tmp.Entry.length == 1) {
        this.costtypes.forEach(function(item) {
          item['disabled'] = false;
        });
      }
    },
    addinvoice() {
      var tmp = this.DataForm;
      tmp.EntryInvoiceinfo.splice(0, 0, {
        Status: '0',
        StatusInfo: '正确',
        InvoiceName: '手工新增',
        InvoiceDate: this.getNowFormatDate(),
        Count: 1,
        Type: 99,
        disabled: false,
        InvoiceNo: 'tmp' + tmp.EntryInvoiceinfo.length
      });
    },
    chooseMyRB() {
      this.myRB = [];
      this.handlegetmyRB();
      this.myRBFormVisible = true;
    },
    SubmitChooseinvoice() {
      var tmp = this.DataForm;
      var items = this.myRBsels.map((item) => item);
      items.forEach(function(element) {
        element.disabled = true,
          tmp.EntryInvoiceinfo.splice(0, 0, element);
      })
      this.myRBFormVisible = false;
      this.getfpsum();
    },
    //双击选择发票
    handleChoose() {
      let row = this.myRBcurrentRow;
      if (!row) {
        this.$message({
          message: "请选择一行数据！",
          type: "error"
        });
        return;
      }
      var tmp = this.DataForm;
      tmp.EntryInvoiceinfo.splice(0, 0, row);
      this.getfpsum();
      this.myRBFormVisible = false
    },
    deleteInvoice(row) {
      var tmp = this.DataForm;
      const index = tmp.EntryInvoiceinfo.findIndex(a => a.InvoiceNo === row.InvoiceNo);
      tmp.EntryInvoiceinfo.splice(index, 1);
      const index2 = this.fileList.findIndex(text => text.name === row.FileName);
      this.fileList.splice(index2, 1);
      this.getfpsum();
    },
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    getfpsum(isupdate) {
      var tmp = this.DataForm;
      //删除原合计
      const index = tmp.EntryInvoiceinfo.findIndex(text => text.InvoiceName === '合计');
      if (index != -1) tmp.EntryInvoiceinfo.splice(index, 1);
      if (tmp.EntryInvoiceinfo.length > 0) {
        //求合计
        var s = 0;
        var s2 = 0;
        var z1 = '0';
        var z2 = '通过';
        tmp.EntryInvoiceinfo.forEach(function(val, idx, arr) {

          // var aa = parseFloat(val.Amount);
          // s = s + aa;
          s += parseFloat(val.Amount);
          s2 += parseFloat(val.Count);
          if (val.Status != '0' && val.Status != '1') {
            z1 = '2';
            z2 = '错误';
          }
        }, 0);
        s = s.toFixed(2);
        // s2 = s2.toFixed(2);

        //判断整体状态
        var heji = {
          InvoiceName: '合计',
          Amount: s,
          Count: s2,
          Status: z1,
          disabled: true,
          StatusInfo: z2,
          Type: 100
        };
        tmp.EntryInvoiceinfo.push(heji);

        // if (tmp.Entry.length === 1 && (tmp.Entry[0].Amount === 0)) {
        if (isupdate != 1) {
          tmp.Entry[0].Amount = s;
        }
        // }
      }

    },
    userchange(row) {
      debugger
      var depid = 0
      var x = this.users.filter((user) => user.uID === row.StaffID)
      if (x.length > 0) {
        depid = this.users.filter((user) => user.uID === row.StaffID)[0].DepID;
      }
      // var depid = this.users.filter((user) => user.uID === row.StaffID)[0].DepID;
      var tmp = this.DataForm;
      tmp.Entry.forEach(function(item) {
        if (item.tmpid == row.tmpid) {
          item.DepID = depid;
          item.CostDepID = depid;
          item.Subject = '002';
          item.CurBudget = 0;
          item.CurSurplus = 0;
          item.CostTypeId = '';
        }
      });
    },
    //获取剩余额度
    newgetbudget(row) {
      var tmpload = this.$loading({
        lock: true,
        text: '正在计算剩余额度',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      var tmp = this.DataForm;
      //校验前置条件
      if (row.StaffID.length == 0) {
        this.$message({
          message: '请选择报销人后再选择费用类型',
          type: 'error'
        });

        tmp.Entry.forEach(function(item) {
          if (item.tmpid == row.tmpid) {
            item.CostTypeId = '';
          }
        });
        tmpload.close();
        return;
      }
      //先把额度置零
      tmp.Entry.forEach(function(item) {
        if (item.tmpid == row.tmpid) {
          item.CurBudget = 0;
          item.CurSurplus = 0;
          item.YearCurSurplus = 0;
        }
      });

      if (!row.hasOwnProperty("YSDATE") || row.YSDATE == null || row.CostTypeId == 0 || row.CostDepID == 0 || row.Subject == 0) {
        tmpload.close();
        return;
      }

      //转换部门编码,后端需要
      this.deps.forEach(function(item) {
        if (item.Id == row.CostDepID) {
          row.DepNo = item.Number;
        }
      });

      //转换项目编码,后端需要
      // this.subjects.forEach(function(item) {
      //   if (item.Id == row.CostDepID) {
      //     row.Subject = item.Number;
      //   }
      // });

      let para = row;
      console.log(para)
      getbudget(para).then((res) => {
        tmp.Entry.forEach(function(item) {
          if (item.tmpid == row.tmpid) {
            item.CurBudget = res.data.response.CurBudget;
            item.CurSurplus = res.data.response.CurSurplus;
            item.YearCurSurplus = res.data.response.YearCurSurplus;
          }
        })
      })
      tmpload.close();
    },
    getallbudget() {
      var tmpload = this.$loading({
        lock: true,
        text: '正在计算剩余额度',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      var _this = this;
      this.DataForm.Entry.forEach(function(item) {
        item.CurBudget = 0;
        item.CurSurplus = 0;

        _this.deps.forEach(function(item2) {
          if (item2.Id == item.CostDepID) {
            item.DepNo = item2.Number;
          }
        });

        let para = item;
        getbudget(para).then((res) => {
          item.CurBudget = res.data.response.CurBudget;
          item.CurSurplus = res.data.response.CurSurplus;
          item.YearCurSurplus = res.data.response.YearCurSurplus;
        })
      });
      tmpload.close();
    },

    UploadUrl: function() {
      var UploadPath = this.huanjing == 'production' ? global.UploadPath : global.testUploadPath;
      return UploadPath;
    },
    handlesuccess(response, file, fileList) {
      debugger
      if (response.success == true) {
        var tmp = this.DataForm;
        for (let index = 0; index < response.response.length; index++) {
          var tmpresponse = response.response[index];
          //如果该发票不在明细内则加入
          if (tmp.EntryInvoiceinfo.filter((item, i) => {
            return item.InvoiceNo == tmpresponse.InvoiceNo;
          }).length == 0) {
            tmp.EntryInvoiceinfo.push(tmpresponse); //加到发票明细中
            // fileList.find(a => a.name == file.name).name = tmpresponse.FileName;//文件改名
          }
          // else { //如果发票重复上传，自动删除
          //   const index = fileList.findIndex(text => text.name === file.name);
          //   fileList.splice(index, 1);
          // }
        }
        this.getfpsum();
      }
      else {
        this.$message({
          showClose: true,
          message: response.msg,
          type: 'error',
          duration: 0
        });
      }

      this.loading = false;
    },
    handleRemove(file, fileList) {
    },
    handlePreview(file) {
      // if (file.status == 'success') {
      //   var fileurl = this.huanjing == 'production' ? 'http://192.168.80.73:1003/api/File/DownFile/' : 'http://localhost:1003/api/File/DownFile/';
      //   let para = file.name;
      //   axios({
      //     // 用axios发送post请求
      //     method: "post",
      //     url: fileurl + "?filename=" + para, // 请求地址 ，也可以传递参数
      //     responseType: "blob" // 表明返回服务器返回的数据类型
      //   }).then((res) => {
      //     var content = res.data;
      //     var blob = new Blob([content]);
      //     var url = URL.createObjectURL(blob);
      //     let link = document.createElement('a')
      //     link.style.display = 'none'
      //     link.href = url
      //     link.setAttribute('download', file.name)
      //     document.body.appendChild(link)
      //     link.click()
      //   });
      // }
    },
    submitUpload(AddorEdit) {

      if (AddorEdit == 'edit') {
        this.$refs['edit-upload'].submit();
      }
      else {
        this.$refs['add-upload'].submit();
      }
      this.loading = true;
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    myRBselectCurrentRow(val) {
      this.myRBcurrentRow = val;
    },
    callFunction(item) {
      this.filters = {
        name: item.search
      };
      this[item.Func].apply(this, item);
    },
    formatRBDate: function(row, column) {
      var a = (!row.CreateTime || row.CreateTime == '') ? '' : util.formatDate.format(new Date(row.CreateTime), 'yyyy-MM-dd hh:mm:ss')
      return a;
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleget();
    },
    myRBhandleCurrentChange(val) {
      this.myRBpage = val;
      this.handlegetmyRB();
    },

    // //获取列表
    // handleget() {
    //   let para = {
    //     page: this.page,
    //     key: this.filters.name
    //   };
    //   this.listLoading = true;
    //   testapi();
    //   getRBListPage(para).then((res) => {
    //     this.total = res.data.response.dataCount;
    //     this.listData = res.data.response.data;
    //     this.listData.forEach(function(item) {
    //       item.EntryInvoiceinfo.forEach(function(item2) {
    //         item2['disabled'] = true;
    //       });
    //     });
    //     this.listLoading = false;
    //   });
    // },
    handleget() {
      let para = {
        page: this.page,
        key: this.filters.name
      };

      this.listLoading = true;
      // 考虑到testapi()可能是测试用途，确保它不会干扰实际的数据获取流程
      // 如果testapi()是必要的，应该在获取数据之前确保它成功执行，或处理其异常
      testapi();

      getRBListPage(para)
        .then(res => {
          // 使用解构赋值简化数据访问
          const { data: { response: { dataCount, data } } } = res;

          if (!dataCount || !data) {
            console.warn('Data is incomplete or missing.');
            // 处理数据缺失的情况，例如设置为空列表或显示默认消息
            this.total = 0;
            this.listData = [];
          } else {
            this.total = dataCount;
            this.listData = data;
            // 使用箭头函数简化代码，遍历过程中设置禁用状态
            this.listData.forEach(item => {
              item.EntryInvoiceinfo.forEach(item2 => {
                item2['disabled'] = true;
              });
            });
          }
          this.listLoading = false;
        })
        .catch(error => {
          console.error('Failed to get RB List Page:', error);
          // 处理请求失败的情况，例如显示错误消息或重试机制
          this.listLoading = false;
        });
    },


    //获取列表
    handlegetmyRB() {
      let para = {
        page: this.myRBpage,
        key: '0'
      };
      getListInvoicePage(para).then((res) => {
        this.myRBtotal = res.data.response.dataCount;
        this.myRB = res.data.response.data;
      });
    },
    //下推
    handlePush() {
      var items = this.sels.map((item) => item);
      debugger
      var checkstatus = true;
      items.forEach(function(element) {
        if (element.Status != "0") checkstatus = false
      })
      if (checkstatus == false) {
        this.listLoading = false;
        this.$message({
          message: "所选申请单存在状态不符合，请刷新后重试",
          type: "error"
        });
        return;
      }
      if (items.length === 0) {
        this.listLoading = false;
        this.$message({
          message: "请勾选需要下推的数据行！",
          type: "error"
        });
        return;
      }

      this.pushFormVisible = true;
    },
    go(path) {
      this.$router.replace({
        path: path,
      });
    },
    //获取用户列表
    getUsers() {
      getUserListPage().then((res) => {
        this.users = res.data.response.data;
      });
    },
    //获取部门列表
    getDeps() {
      let para = {
        page: this.page,
        key: this.filters.name
      };
      this.listLoading = true;

      getDepListPage(para).then((res) => {
        this.deps = res.data.response.data;
        this.listLoading = false;
      });
    },
    //获取项目
    getSubjects() {
      var filters = {
        name: 'SUBJECTS'
      };
      let para = {
        page: this.page,
        key: filters.name
      };
      this.listLoading = true;

      getDictionaryListPage(para).then((res) => {
        this.subjects = res.data.response.data[0].Entry;
        this.listLoading = false;
      });
    },
    //获取费用类型列表
    getCosts() {
      let para = {
        page: this.page,
        key: this.filters.name
      };
      this.listLoading = true;

      getCostTypeListPage(para).then((res) => {
        this.costtypes = res.data.response.data;
        this.listLoading = false;
      });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }

      if (row.Status == '1') {
        this.status = 2;
      }
      else {
        this.status = 1;
      }
      this.FormVisible = true;
      this.DataForm = Object.assign({}, row);
      // this.editForm.EntryInvoiceinfo.forEach(function(item) {
      //   if (item.Status == undefined) item.Status = "正确";
      // });
      this.getfpsum(1);
      this.getallbudget();
      console.log("this.status", this.status)

    },
    //显示新增界面
    handleAdd() {
      this.status = 0;
      this.FormVisible = true;
      this.fileList = [];
      this.DataForm = {
        Amount: 0,
        YSDATE: '',
        Entry: [],
        EntryInvoiceinfo: []
      };
      this.addreuser();
      console.log("this.status", this.status)
    },
    //下推
    pushSubmit() {
      var message = this.pushForm.Remark;
      message = message.replace(/^\s*|\s*$/g, ''); // 去除字符串内两头的空格
      if (message.length === 0) {
        this.listLoading = false;
        this.$message({
          message: "填写报销说明！",
          type: "error"
        });
        return;
      }
      this.$confirm("确认下推选中记录吗？", "提示", {
        type: "warning",
      })
        .then(() => {

          this.listLoading = true;
          var para = {
            message: this.pushForm.Remark,
            IsDG: this.pushForm.IsDG,
            SKFMC: this.pushForm.SKFMC,
            SKFKHYH: this.pushForm.SKFKHYH,
            SKFYHZH: this.pushForm.SKFYHZH,
            ids: []
          };
          var items = this.sels.map((item) => item);
          items.forEach(function(element) {
            para.ids.push(element.Id);
          });


          // para = JSON.stringify(para)

          PushRB(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.pushFormVisible = false;
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: '下推成功',
                type: 'success'
              });
              this.pushFormVisible = false;
              this.handleget();
              this.go("/ListReimbursement/ListReimbursement");
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              });
            }
          })
            ;
        })
        .catch(() => { this.listLoading = false; });
    },
    //编辑
    editSubmit: function() {
      this.$confirm('确认提交吗？', '提示', {}).then(() => {
        this.Loading = true;
        debugger

        var msg = this.Verification(this.DataForm);
        if (msg.length > 0) {
          this.Loading = false;
          this.$message({
            dangerouslyUseHTMLString: true,
            showClose: true,
            message: msg,
            type: 'error',
            duration: 0
          });
          return;
        }
        debugger
        let para = Object.assign({}, this.DataForm);
        editRB(para).then((res) => {

          if (util.isEmt.format(res)) {
            this.Loading = false;
            return;
          }
          if (res.data.success) {
            this.Loading = false;
            this.$message({
              message: res.data.msg,
              type: 'success'
            });
            this.FormVisible = false;
            this.handleget();
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }
        });
      });
    },
    //新增
    addSubmit: function() {
      this.$confirm('确认提交吗？', '提示', {}).then(() => {
        this.Loading = true;
        var msg = this.Verification(this.DataForm);
        if (msg.length > 0) {
          this.Loading = false;
          this.$message({
            dangerouslyUseHTMLString: true,
            showClose: true,
            message: msg,
            type: 'error',
            duration: 0
          });
          return;
        }

        let para = Object.assign({}, this.DataForm);

        addRB(para).then((res) => {
          if (util.isEmt.format(res)) {
            this.Loading = false;
            return;
          }
          if (res.data.success) {
            this.Loading = false;
            this.$message({
              message: res.data.msg,
              type: 'success'
            });
            this.FormVisible = false;
            this.handleget();
          }
          else {
            this.Loading = false;
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }
        });
      });
    },
    Verification(info) {
      var msg = '';
      //校验预算额度
      msg = this.checkAmounts(info.Entry);

      //校验
      if (info.Entry.length < 1) msg += "请选择报销人！<br/>";
      //校验
      if (info.EntryInvoiceinfo.length < 1) msg += "请上传发票！<br/>";

      var ispass = false;
      //校验
      info.Entry.forEach(function(item) {
        if (item.Amount == 0) ispass = true;
      });
      if (ispass) {
        msg += "报销金额不能为0<br/>";
        ispass = false
      }

      //发票信息校验
      info.EntryInvoiceinfo.forEach(function(item) {
        if (item.Status == '2') ispass = true;
      });
      if (ispass) {
        msg += "存在发票信息校验失败，请检查或删除该发票！<br/>";
      }


      //校验发票总额与报销额总额
      var bxsum = 0;
      var fpsum = 0;
      info.Entry.forEach(function(val, idx, arr) {
        bxsum += parseFloat(val.Amount);
      }, 0);

      var tmp = info.EntryInvoiceinfo.filter((a) => a.InvoiceName != '合计');
      tmp.forEach(function(val, idx, arr) {
        fpsum += parseFloat(val.Amount);
      }, 0);
      bxsum = Number(bxsum.toFixed(2));
      fpsum = Number(fpsum.toFixed(2));


      if (bxsum > fpsum) {
        msg += "发票总额低于报销总额，请检查！<br/>";
      }
      return msg;
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      debugger
      if (row == null) {
        this.$message({
          message: "请选中一行数据进行删除，注意，不是勾选！",
          type: "error"
        });
        return;
      }
      if (row.Status == "1") {
        this.$message({
          message: "该申请单已锁定，请前往报销单撤销后再进行操作！",
          type: "error"
        });
        return;
      }
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error"
        });
        return;
      }
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.listLoading = true;
        let para = { Id: row.Id };
        removeRB(para).then((res) => {
          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          if (res.data.success) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }
          this.handleget();
        });
      }).catch(() => {
      });
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    myRBselsChange: function(sels) {
      this.myRBsels = sels;
    },
    formatData: function(row, column) {
      return (!row.InvoiceDate || row.InvoiceDate == '') ? '' : util.formatDate.format(new Date(row.InvoiceDate), 'yyyy-MM-dd');
    },
    formatData2: function(row, column) {
      return (!row.ModifyTime || row.ModifyTime == '') ? '' : util.formatDate.format(new Date(row.ModifyTime), 'yyyy-MM-dd');
    },
    formatIsDG: function(row, column) {
      return row.IsDG ? '是' : '否';
    }

  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getHeight);
    //一定记得在页面关闭前销毁监听的resize事件，不然多次刷新后页面会因为内存泄漏崩溃
  },
  mounted() {
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    this.handleget();
    this.getUsers();
    this.getDeps();
    this.getCosts();
    this.getSubjects();
    // this.addForm.Entry = [];
    this.DataForm.Entry = [];

    let tokenStr = window.localStorage.Token;
    this.headers = {
      Authorization: "Bearer " + tokenStr
    };

    this.huanjing = process.env.NODE_ENV;
    UploadPath = this.huanjing == 'production' ? global.UploadPath : global.testUploadPath;

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  }
}

</script>

<style scoped>
.el-input__inner {
  width: 80%;
}
.el-row {
  top: 20px;
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
}
.dialogClass .el-dialog__body {
  padding: 0 0.3rem;
  padding-top: 0px;
  padding-bottom: 0px;
  color: #606266;
  font-size: 14px;
}
.dialogClass .el-dialog__header {
  padding-top: 20px;
  padding-bottom: 0px;
  margin-left: 20px;
  color: #606266;
  font-size: 14px;
}
.dialogrowClass .el-row {
  padding: 0 0;
  align-items: center;
}
.pushrow div {
  margin: 0px 0.2rem;
}

/* 日期选择器样式优化 */
.entry-table .el-date-editor,
.invoice-table .el-date-editor {
  width: 100% !important;
}

.entry-table .el-date-editor.el-input,
.invoice-table .el-date-editor.el-input {
  width: 100% !important;
}

.entry-table .el-date-editor.el-input__inner,
.invoice-table .el-date-editor.el-input__inner {
  width: 100% !important;
}

.entry-table .el-table__cell .el-date-editor,
.invoice-table .el-table__cell .el-date-editor {
  width: 100% !important;
}

/* 报销明细表列宽优化 */
.entry-table .el-table__cell {
  padding: 2px 0;
}

.entry-table .el-date-editor--date {
  width: 100% !important;
}

/* 预算区间列宽优化 */
.entry-table .el-table__cell[data-column-id="RBDate"],
.entry-table .el-table__cell[data-column-id="YSDATE"] {
  min-width: 150px !important;
}
</style>
